var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEleoRaw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.17 118.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M126.24,37.52c-3.99-.68-8.82-2.7-10.65-5.85-2.87-4.95-5.11-8.31-8.11-12.13,6.28-8.59,7.07-13.1,6.92-13.63-.25-.88-1.42-.92-2.33-.99-4.47-.34-13.41,2.39-15.8,3.74-9.5-6.2-20.44-7.68-30.85-7.02-5.33,.09-10.55,1.66-15,4-3.69-1.68-15-4.11-24.3-2.32-.82,2.2,3.18,10.48,9.87,14.15-.51,.78-2.61,3.77-3.27,4.67-5.23,7.1-9.65,15.33-13.51,23.37C-1.97,89.54,29.61,107.53,63.63,108.56c.73,2.64,1.74,5.23,3.05,7.72,.23,.45,.53,.93,1.1,1.11,.82,.25,1.68-.28,2.24-.82,2.14-2.09,2.88-4.84,4.17-7.34,.15-.29,.32-.59,.56-.84,3.11-.13,6.07-.3,8.89-.51,.04,.16,.07,.32,.09,.47,.39,2.77,1.37,5.49,2.89,8,.28,.46,.64,.96,1.26,1.08,1.05,.21,1.83-.75,2.23-1.56,1.13-2.24,2.25-4.47,3.38-6.71,.38-.75,.76-1.51,1.42-2.11,.21-.2,.47-.37,.74-.51,26.49-4.19,34.87-17.26,28.43-48.74,1.53,.05,3.45,.62,4.6-.76,1.81-2.18-.46-4.34-1.11-5.89,2.61,.36,3.83-.05,5.15-.37,1.31-.32,2.58-1.67,2.05-2.91-.63-1.47-3.31-1.75-3.14-3.34,.1-.99,1.64-1.02,2.55-1.42,1.09-.48,2.94-1.46,2.39-3.73-.7-2.93-6.01-1.13-10.33-1.87Z",
    style: {
      fill: "#fff",
      stroke: "#1c1c1c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.98,48.52c-.52,5.77-6.1,2.77-13.47,2.12-7.37-.66-13.74,1.27-13.22-4.5,.52-5.77,6.91-9.92,14.28-9.26,7.37,.66,12.93,5.87,12.41,11.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,45.82c.62,5.76-5.44,3.91-12.8,4.7-7.36,.79-13.23,3.93-13.85-1.84-.62-5.76,4.84-11.08,12.2-11.87,7.36-.79,13.82,3.24,14.44,9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.51,26.95c4.25,7.62,2.21,30.58-2.21,33-3.47-.54-5.29-25.14-5.06-32.24,2.11-.8,5.31-.99,7.27-.77Z",
    style: {
      fill: "#ffda39",
      stroke: "#1c1c1c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.22,109.17c.38-.75,.76-1.5,1.42-2.11,.21-.2,.47-.37,.74-.52,18.27-2.89,27.96-9.44,29.7-24.41,0-.08-.02-.17-.03-.25-.05-.38-.11-.78-.17-1.17-.05-.31-.09-.61-.14-.92-.07-.4-.15-.81-.22-1.21-.06-.32-.12-.64-.19-.97-.09-.41-.18-.84-.28-1.26-.08-.34-.15-.68-.24-1.03-.04-.16-.08-.32-.12-.48-2.77,.5-5.33,1.83-7.7,3.11-8.45,4.59-17.09,9.36-27.14,11.35-9.69,1.92-19.97,1.1-29.75-.52-9.78-1.62-19.35-4.01-29.23-5.25-4.37-.55-9.13-.82-12.95,.88-.66,.29-1.25,.66-1.8,1.05,7.43,15.47,27.37,22.48,48.23,23.11,.73,2.64,1.74,5.23,3.05,7.72,.23,.45,.53,.93,1.1,1.11,.82,.25,1.68-.28,2.24-.82,2.14-2.09,2.88-4.84,4.17-7.34,.15-.29,.32-.59,.56-.84,3.11-.13,6.07-.3,8.89-.51,.04,.16,.07,.32,.09,.47,.39,2.77,1.37,5.49,2.89,8,.28,.46,.64,.96,1.26,1.08,1.05,.21,1.83-.75,2.23-1.56,1.13-2.24,2.25-4.47,3.38-6.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M9.44,8.29c26.92-13.37,57-.59,69.49,18.53,1.95,0-1.34,0,0,0s-1.95,0,0,0C83.9,16.3,100.04-.4,121.45,6.54",
    style: {
      fill: "none",
      stroke: "#1c1c1c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.81,
    cy: 36.85,
    r: 5.81,
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.22,
    cy: 36.83,
    r: 5.81,
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.64,
    cy: 34.78,
    rx: 1.1,
    ry: 1.49,
    transform: "translate(1.64 74.02) rotate(-40.32)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.3,
    cy: 34.78,
    rx: 1.1,
    ry: 1.49,
    transform: "translate(-8.18 47.27) rotate(-40.32)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.63,28.13c-1.33,2.23-1.95,3.65-3.1,5.22-3.99,5.46-10.74,6.23-16.6,6.49-1.33,.06-2.67,.07-3.95,.55-1.28,.48-2.51,1.49-3.13,3.06-.61,1.58-.44,3.76,.62,4.84,.81,.83,1.91,.86,2.93,.87,.93,0,1.87,0,2.8,0,.35,0,.72,0,1.02,.24,.97,.73,.51,2.7,.79,4.14,.24,1.24,1.13,2.12,2.06,2.4,.93,.28,1.91,.06,2.83-.29,1.15-.43,2.63-.92,3.34,.37,.19,.35,.28,.78,.41,1.19,.61,2.03,2.11,3.52,3.73,3.72s3.3-.91,4.17-2.76",
    style: {
      fill: "#fff",
      stroke: "#1c1c1c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEleoRaw);
export default __webpack_public_path__ + "static/media/eleo_raw.fafd7ae055831cd8b3d3f4ce01fd2d01.svg";
export { ForwardRef as ReactComponent };